  export default {
	"当前语言": "Cn",

	"公共.没有更多数据了": "暫無更多資料",
	"公共.加载中": "載入中",
	"公共.下拉刷新": "下拉重新整理",
	"公共.释放刷新": "釋放重新整理",
	"公共.链接钱包": "連接錢包",



	"首页.轮播.标题": "讓現實資產可信、安全、即時地流動在鏈上",
	"首页.轮播.描述1": "向真實世界資產",
	"首页.轮播.描述2": "AI驅動性能公鏈",
	"首页.以太坊": "以太坊",
	"首页.企业绩效管理": "企業績效管理",
	"首页.仲裁委员会": "仲裁委員會",
	"首页.探索DApps": "探索DApps",
	"首页.发现去中心化应用程序": "發現去中心化應用程序",
	"首页.查看所有Dapps": "查看所有Dapps",
	"首页.战略合作伙伴": "戰略合作夥伴",
	"首页.值得信赖的生态系统合作伙伴": "值得信賴的生態系統合作夥伴",
	"首页.全部": "全部",
	"首页.去中心化金融": "去中心化金融",
	"首页.非同质化代币": "非同質化代幣",
	"首页.最新消息": "最新消息",
	"首页.保持对Web3关注": "保持對Web3關注",
	"首页.官方频道": "官方頻道",

	"首页.官方频道.推特.名称": "推特",
	"首页.官方频道.推特.描述": "@web3 平台",
	"首页.官方频道.Discord.名称": "Discord",
	"首页.官方频道.Discord.描述": "@web3 平台",
	"首页.官方频道.电报.名称": "電報",
	"首页.官方频道.电报.描述": "官方更新",
	"首页.官方频道.GitHub.名称": "GitHub",
	"首页.官方频道.GitHub.描述": "開源",
    "首页.官方频道.RoonChain.官网": "RoonChain",
	"首页.官方频道.RoonChain.描述": "官網",

	"首页.标签.Defi": "DeFi",
	"首页.标签.数据分析": "資料分析",
	"首页.标签.链游": "鏈遊",
	"首页.标签.其他": "其他",
	"首页.标签.DEX": "DEX",

	"首页.合作伙伴.Solana.描述": "Solana 是一個為大規模採用而構建的區塊鏈。快速、可組合、綠色、全球去中心化分布。",
	"首页.合作伙伴.CoinStats.描述": "一站式代幣資產追蹤工具，輕鬆高效管理資產組。",
	"首页.合作伙伴.Shaga.描述": "Shaga 致力於帶來革命性遊戲體驗。",
	"首页.合作伙伴.Grass.描述": "使用 Grass 共享未使用的網際網路頻寬獲得獎勵。",
	"首页.合作伙伴.Jupiter.描述": "致力於打造加密領域最佳交易所並成為 DeFi 巨頭。",
	"首页.合作伙伴.boop.fun.描述": "建設 Meme 幣社群，質押 BOOP，解鎖空投獎勵。",

	"闪兑.闪兑中心": "RGT 兌换中心",
	"闪兑.闪兑": "閃兌",
	"闪兑.即时互换": "即時互換",
	"闪兑.快速兑换 · 实时到账 · 20:1比例": "快速兌換 · 實時到賬 · 20:1比例",
	"闪兑.极速闪兑": "極速閃兌",
	"闪兑.安全可靠": "安全可靠",
	"闪兑.RGT余额": "RGT餘額",
	"闪兑.ROON余额": "ROON餘額",
	"闪兑.可用于闪兑": "可用於閃兌",
	"闪兑.闪兑获得": "閃兌獲得",
	"闪兑.节点等级": "節點等級",
	"闪兑.闪兑比例": "閃兌比例",
	"闪兑.闪兑优惠": "閃兌優惠",
	"闪兑.手续费": "手續費",
	"闪兑.闪兑数量": "閃兌數量",
	"闪兑.输入RGT数量": "輸入RGT數量",
	"闪兑.最低": "最低",
	"闪兑.余额": "餘額",
	"闪兑.将获得": "將獲得",
	"闪兑.立即闪兑": "立即閃兌",
	"闪兑.闪兑说明": "閃兌說明",
	"闪兑.极速到账": "極速到賬",
	"闪兑.闪兑后ROON立即到账，无需等待": "閃兌後ROON立即到賬，無需等待",
	"闪兑.安全保障": "安全保障",
	"闪兑.零手续费": "零手續費",
	"闪兑.享受零手续费特权": "享受零手續費特權",
	"闪兑.闪兑成功": "閃兌成功",
	"闪兑.ROON已成功转入您的钱包": "ROON已成功轉入您的錢包",
	"闪兑.消耗RGT": "消耗RGT",
	"闪兑.获得ROON": "獲得ROON",
	"闪兑.确认": "確認",


	"ROON锁仓.ROON锁仓": "ROON鎖倉",
	"ROON锁仓.线性解锁": "線性解鎖",
	"ROON锁仓.安全锁仓 · 线性解锁 · 随时提取": "安全鎖倉 · 線性解鎖 · 隨時提取",
	"ROON锁仓.安全锁仓": "安全鎖倉",
	"ROON锁仓.总锁仓全部": "總鎖倉全部",
	"ROON锁仓.解锁进度": "解鎖進度",
	"ROON锁仓.已解锁": "已解鎖",
	"ROON锁仓.解锁周期": "解鎖週期",
	"ROON锁仓.周期": "週期",
	"ROON锁仓.可提取金额": "可提取金額",
	"ROON锁仓.提取ROON": "提取ROON",
	"ROON锁仓.输入提取数量": "輸入提取數量",
	"ROON锁仓.最低": "最低",
	"ROON锁仓.可提取": "可提取",
	"ROON锁仓.立即提取": "立即提取",
	"ROON锁仓.锁仓说明": "鎖倉說明",
	"ROON锁仓.将提取到钱包": "將提取到錢包",
	"ROON锁仓.ROON已成功转入您的钱包": "ROON已成功轉入您的錢包",
	"ROON锁仓.闪兑获得的ROON将按照固定周期线性": "閃兌獲得的ROON將按照固定週期線性",
	"ROON锁仓.随时提取": "隨時提取",
	"ROON锁仓.安全保障": "安全保障",
	"ROON锁仓.智能合约锁仓，资金安全有保障": "智能合約鎖倉，資金安全有保障",
	"ROON锁仓.提取成功": "提取成功",
	"ROON锁仓.提取金额": "提取金額",
	"ROON锁仓.确认": "確認",

	"USDR闪兑.USDR闪兑": "ROON 入門購買",
	"USDR闪兑.闪兑": "閃兌",
	"USDR闪兑.余额": "餘額",
	"USDR闪兑.极速闪兑": "極速閃兌",
	"USDR闪兑.快速兑换 · 安全可靠": "快速兌換 · 安全可靠",
	"USDR闪兑.安全可靠": "安全可靠",
	"USDR闪兑.闪兑比例": "閃兌比例",
	"USDR闪兑.实时汇率": "實時匯率",
	"USDR闪兑.闪兑数量": "閃兌數量",
	"USDR闪兑.输入USDR数量": "輸入USDR數量",
	"USDR闪兑.将获得": "將獲得",
	"USDR闪兑.立即闪兑": "立即閃兌",
	"USDR闪兑.闪兑记录": "閃兌記錄",
	"USDR闪兑.提现记录": "提現記錄",
	"USDR闪兑.兑换成功": "兌換成功",
	"USDR闪兑.已完成": "已完成",
	"USDR闪兑.处理中": "處理中",
	"USDR闪兑.消耗": "消耗",
	"USDR闪兑.获得": "獲得",
	"USDR闪兑.提现": "提現",
	"USDR闪兑.提现金额": "提現金額",
	"USDR闪兑.可用余额": "可用餘額",
	"USDR闪兑.提现数量": "提現數量",
	"USDR闪兑.充值数量": "充值数量",
	"USDR闪兑.请输入数量": "請輸入數量",
	"USDR闪兑.提现地址": "提現地址",
	"USDR闪兑.输入钱包地址": "輸入錢包地址",
	"USDR闪兑.确认": "確認",


	"ROONMining.LP池": "LP池",
	"ROONMining.我的流动性": "我的流動性",
	"ROONMining.我的LP数据": "我的LP數據",
	"ROONMining.累计收益": "累計收益",
	"ROONMining.剩余天数": "剩餘天數",
	"ROONMining.天": "天",
	"ROONMining.推荐收益": "推薦收益",
	"ROONMining.总本金": "總本金",
	"ROONMining.添加LP": "添加LP",
	"ROONMining.我的LP": "我的LP",
	"ROONMining.查看详情": "查看詳情",
	"ROONMining.明细": "明細",
	"ROONMining.提现": "提現",
	"ROONMining.更多功能": "更多功能",
	"ROONMining.推荐系统": "推薦系統",
	"ROONMining.直推10%收益": "直推10%收益",
	"ROONMining.分红池": "分紅池",
	"ROONMining.多重收益分配": "多重收益分配",
	"ROONMining.NFT权益": "NFT權益",
	"ROONMining.节点与矿机": "節點與礦機",
	"ROONMining.挖矿规则": "挖礦規則",
	"ROONMining.20天为一个周期,中间不可撤出LP": "20天為一個週期,中間不可撤出LP",
	"ROONMining.LP每个钱包地址最多添加一次LP": "LP每個錢包地址最多添加一次LP",
	"ROONMining.每个LP每天收益1个ROON": "每個LP每天收益1個ROON",
	"ROONMining.20天到期:本金+20个ROON": "20天到期:本金+20個ROON",
	"ROONMining.保障本金+利息,不受价格波动影响": "保障本金+利息,不受價格波動影響",

	"添加流动性.添加流动性": "添加流動性",
	"添加流动性.重要提示": "重要提示",
	"添加流动性.每个钱包地址仅可添加一次LP，20天锁定期内无法撤出，请谨慎操作": "每個錢包地址每天僅可添加一次LP，20天鎖定期內無法撤出，請謹慎操作",
	"添加流动性.添加LP组合": "添加LP組合",
	"添加流动性.数量": "數量",
	"添加流动性.余额": "餘額",
	"添加流动性.请输入USDR数量": "請輸入USDR數量",
	"添加流动性.最大": "最大",
	"添加流动性.请输入ROON数量": "請輸入ROON數量",
	"添加流动性.LP组成比例为": "LP組成比例為",
	"添加流动性.挖矿规则": "挖礦規則",
	"添加流动性.锁走周期20天，期间无法撤出": "鎖走週期20天，期間無法撤出",
	"添加流动性.每天固定收益1个ROON代币": "每天固定收益1個ROON代幣",
	"添加流动性.保障本金安全，不受市场价格波动影响": "保障本金安全，不受市場價格波動影響",
	"添加流动性.每个钱包地址仅可添加一次LP": "每個錢包地址每天僅可添加一次LP",
	"添加流动性.所有数据链上透明可查": "所有數據鏈上透明可查",
	"添加流动性.确认添加LP": "確認添加LP",
	"添加流动性.您即将添加": "您即將添加",
	"添加流动性.到流动性池": "到流動性池",
	"添加流动性.锁定期": "鎖定期",
	"添加流动性.天": "天",
	"添加流动性.预计收益": "預計收益",

	"我的LP.我的LP": "我的LP",
	"我的LP.添加流动性": "添加流動性",
	"我的LP.进行中": "進行中",
	"我的LP.已完成": "已完成",
	"我的LP.总价值": "總價值",
	"我的LP.剩余": "剩餘",
	"我的LP.天": "天",
	"我的LP.锁定中": "鎖定中",
	"我的LP.移除LP": "移除LP",
  "我的LP.已移除": "已移除",
  "LP日志.日志明细": "日志明细",
  "LP日志.确定复投LP": "确定复投 LP",
  "LP日志.确定复投": "确定复投",
	"我的LP.确认移除LP": "確認移除LP",
	"我的LP.您即将移除LP并获得以下资产": "您即將移除LP並獲得以下資產",
	"我的LP.本金返还": "本金返還",
	"我的LP.收益": "收益",
	"我的LP.总计": "總計",
	"我的LP.确认移除": "確認移除",

	"持有LP数": "持有LP數",
	"我的LP": "我的LP",
	"暂无LP记录": "暫無LP記錄",

	"推荐系统.推荐系统": "推薦系統",
	"推荐系统.我的团队": "我的團隊",
	"推荐系统.直推人数": "直推数量",
	"推荐系统.团队总人数": "團隊總数量",
	"推荐系统.累计收益": "累計收益",
	"推荐系统.待领取收益": "待領取收益",
	"推荐系统.领取收益": "領取收益",
	"推荐系统.我的推荐链接": "我的推薦鏈接",
	"推荐系统.复制连接": "複製連接",
	"推荐系统.分享链接给好友，好友添加LP后您将获得其收益的10%作为推荐奖": "分享鏈接給好友，好友添加LP後您將獲得其收益的10%作為推薦獎",
	"推荐系统.当前等级权益": "當前等級權益",
	"推荐系统.个直推": "個直推",
	"推荐系统.推荐奖励": "推薦獎勵",
	"推荐系统.当前等级": "當前等級",
	"推荐系统.领取成功": "領取成功",
	"推荐系统.已成功领取": "已成功領取",
	"推荐系统.复制": "複製",
	"推荐系统.收益已发送到您的钱包地址": "收益已發送到您的錢包地址",
	"推荐系统.上级地址": "上级地址",

	"分红池.分红池": "分紅池",
	"分红池.持有者": "持有者",
	"分红池.锁仓": "鎖倉",
	"分红池.FOMO": "FOMO",
	"分红池.保险": "保險",

	"分红池.LP持有者分红": "LP持有者分紅",
	"分红池.分红奖池总额": "分紅獎池總額",
	"分红池.我的LP": "我的LP",
	"分红池.持有者列表": "持有者列表",
	"分红池.分红规则": "分紅規則",
	"分红池.盈利的25%自动分配给所有LP持有者": "盈利的25%自動分配給所有LP持有者",
	"分红池.按照LP持有比例进行分红": "按照LP持有比例進行分紅",
	"分红池.每周自动发放到钱包地址": "每週自動發放到錢包地址",
	"分红池.下次分红时间": "下次分紅時間",

	"分红池.锁仓记录": "鎖倉記錄",
	"分红池.查看所有ROON锁仓记录": "查看所有ROON鎖倉記錄",
	"分红池.开始日期": "開始日期",
	"分红池.锁定中": "鎖定中",
	"分红池.锁仓时长": "鎖倉時長",
	"分红池.已锁定": "已鎖定",
	"分红池.天": "天",
	"分红池.剩余时间": "剩餘時間",
	"分红池.已完成": "已完成",
	"分红池.锁仓已完成，可领取": "鎖倉已完成，可領取",
	"分红池.锁仓说明": "鎖倉說明",
	"分红池.锁走期为1年，期间无法提取": "鎖走期為1年，期間無法提取",
	"分红池.到期后获得本金+固定收益": "到期後獲得本金+固定收益",
	"分红池.收益来自盈利分配池": "收益來自盈利分配池",

	"分红池.FOMO池": "FOMO池",
	"分红池.奖池总额": "獎池總額",
	"分红池.倒计时": "倒計時",
	"分红池.最后参与": "最後參與",
	"分红池.排行榜（前20名）": "排行榜（前20名）",

	"分红池.奖励分配规则": "獎勵分配規則",
	"分红池.排名": "排名",
	"分红池.奖励": "獎勵",
	"分红池.第": "第",
	"分红池.名": "名",
	"分红池.平分": "平分",
	"分红池.FOMO规则": "FOMO規則",
	"分红池.48小时内无新增参与则触发分配": "48小時內無新增參與則觸發分配",
	"分红池.保险池每10天转入10%到FOMO池": "保險池每10天轉入10%到FOMO池",
	"分红池.前20名按排名获得奖励": "前20名按排名獲得獎勵",

	"分红池.保险池": "保險池",
	"分红池.保险池总额": "保險池總額",
	"分红池.待转入FOMO池": "待轉入FOMO池",
	"分红池.下次转入": "下次轉入",
	"分红池.天后": "天後",
	"分红池.资金流向": "資金流向",
	"分红池.盈利的25%进入保险池": "盈利的25%進入保險池",
	"分红池.每10天转入保险池的10%": "每10天轉入保險池的10%",
	"分红池.保险池作用": "保險池作用",
	"分红池.保障系统稳定运行": "保障系統穩定運行",
	"分红池.定期为FOMO池注入资金": "定期為FOMO池注入資金",
	"分红池.应对市场波动风险": "應對市場波動風險",


	"NFT权益.NFT权益": "NFT權益",
	"NFT权益.NFT权益系统": "NFT權益系統",
	"NFT权益.节点与矿机双重收益": "節點與礦機雙重收益",
	"NFT权益.我的NFT": "我的NFT",
	"NFT权益.NFT收益": "NFT收益",
	"NFT权益.节点NFT": "節點NFT",
	"NFT权益.矿机NFT": "礦機NFT",

	"NFT权益.超级节点": "超級節點",
	"NFT权益.专属权益": "專屬權益",
	"NFT权益.20%额外收益": "20%額外收益",
	"NFT权益.优先提现权": "優先提現權",
	"NFT权益.治理投票权": "治理投票權",
	"NFT权益.专属客服": "專屬客服",
	"NFT权益.价格": "價格",
	"NFT权益.总量": "總量",
	"NFT权益.剩余": "剩餘",
	"NFT权益.立即购买": "立即購買",
	"NFT权益.已拥有": "已擁有",

	"NFT权益.钻石矿机": "鑽石礦機",
	"NFT权益.传说": "傳說",
	"NFT权益.算力": "算力",
	"NFT权益.日产出": "日產出",
	"NFT权益.史诗": "史詩",

	"NFT权益.累计收益": "累計收益",
	"NFT权益.查看详情": "查看詳情",
	"NFT权益.NFT权益说明": "NFT權益說明",
	"NFT权益.节点NFT提供额外收益加成和治理权": "節點NFT提供額外收益加成和治理權",
	"NFT权益.矿机NFT提供持续的挖矿产出": "礦機NFT提供持續的挖礦產出",
	"NFT权益.所有NFT权益永久有效": "所有NFT權益永久有效",

	"质押.质押中": "質押中",
	"质押.收益": "收益",
	"质押.ROON锁仓": "ROON鎖倉",
	"质押.天": "天",
	"质押.年化收益率": "年化收益率",
	"质押.最低": "最低",
	"质押.质押金额": "質押金額",
	"质押.输入质押金额": "輸入質押金額",
	"质押.最大": "最大",
	"质押.余额": "餘額",
	"质押.立即质押": "立即質押",
	"质押.我的质押": "我的質押",
	"质押.查看全部质押": "查看全部質押",
	"质押.进行中": "進行中",
	"质押.天锁定": "天鎖定",
	"质押.年百分率": "年收益率",
	"质押.质押进度": "質押進度",
	"质押.剩余": "剩餘",
	"质押.累计收益": "累計收益",
	"质押.详情": "詳情",

	"销毁挖矿.销毁挖矿": "銷毀挖礦",
	"销毁挖矿.实时销毁数据": "實時銷毀數據",
	"销毁挖矿.全网销毁": "全網銷毀",
	"销毁挖矿.我的销毁": "我的銷毀",
	"销毁挖矿.占比": "佔比",
	"销毁挖矿.分享收益": "分享收益",
	"销毁挖矿.提现": "提現",
	"销毁挖矿.明细": "明細",
	"销毁挖矿.已销毁": "已銷毀",
	"销毁挖矿.锁仓中": "鎖倉中",
	"销毁挖矿.今日可领": "今日可領",
	"销毁挖矿.开始销毁": "開始銷毀",
	"销毁挖矿.销毁记录": "銷毀記錄",
	"销毁挖矿.选择销毁档位": "選擇銷毀檔位",
	"销毁挖矿.个档位可选": "個檔位可選",
	"销毁挖矿.天": "天",
	"销毁挖矿.确认销毁": "確認銷毀",
	"销毁挖矿.销毁挖矿": "銷毀挖礦",
	"销毁挖矿.团队": "團隊",
	"销毁挖矿.释放进度": "釋放進度",
	"销毁挖矿.总收益": "總收益",
	"销毁挖矿.每日释放": "每日釋放",
	"销毁挖矿.已到账": "已到賬",
	"销毁挖矿.待释放": "待釋放",
	"销毁挖矿.自动释放中": "自動釋放中",

	"销毁我的团队.我的团队": "我的團隊",
	"销毁我的团队.邀请好友": "邀請好友",
	"销毁我的团队.团队列表": "團隊列表",
	"销毁我的团队.直推人数": "直推人數",
	"销毁我的团队.直推收益": "直推收益",
	"销毁我的团队.我的邀请码": "我的邀請碼",
	"销毁我的团队.复制": "複製",
	"销毁我的团队.我的邀请码": "我的邀請碼",
	"销毁我的团队.复制链接": "複製鏈接",
	"销毁我的团队.分享链接": "分享鏈接",
	"销毁我的团队.邀请规则": "邀請規則",
	"销毁我的团队.直推好友销毁可获得5%奖励": "直推好友銷毀可獲得5%獎勵",
	"销毁我的团队.团队等级越高，极差收益越多": "團隊等級越高，極差收益越多",
	"销毁我的团队.NFT节点极差:1%-5%": "NFT節點極差:1%-5%",
	"销毁我的团队.矿机领航者极差:1%-5%": "礦機領航者極差:1%-5%",
	"销毁我的团队.流动性挖矿极差:R1-R10(1%-10%)": "流動性挖礦極差:R1-R10(1%-10%)",
	"销毁我的团队.质押NFT解锁团队奖励": "質押NFT解鎖團隊獎勵",
	"销毁我的团队.质押NFT后可获得团队极差奖励(1%-5%)，享受更多收益": "質押NFT後可獲得團隊極差獎勵(1%-5%)，享受更多收益",
	"销毁我的团队.立即质押NFT": "立即質押NFT",
	"销毁我的团队.我的等级": "我的等級",
	"销毁我的团队.极差": "極差",
	"销毁我的团队.领航者": "領航者",
	"销毁我的团队.直推收益": "直推收益",
	"销毁我的团队.团队收益": "團隊收益",
	"销毁我的团队.直推人数": "直推人數",
	"销毁我的团队.团队总人数": "團隊總人數",
	"销毁我的团队.团队销毁量": "團隊銷毀量",
	"销毁我的团队.直推成员": "直推成員",
	"销毁我的团队.共": "共",
	"销毁我的团队.人": "人",
	"销毁我的团队.销毁量": "銷毀量",
	"销毁我的团队.等级说明": "等級說明",
	"销毁我的团队.R1-R10:流动性挖矿等级，极差1%-10%": "R1-R10:流動性挖礦等級，極差1%-10%",
	"销毁我的团队.NFT节点:质押NFT获得，极差1%-5%": "NFT節點:質押NFT獲得，極差1%-5%",
	"销毁我的团队.矿机领航者:团队销毁达标，极差1%-5%": "礦機領航者:團隊銷毀達標，極差1%-5%",
	"销毁我的团队.等级越高，团队收益越多": "等級越高，團隊收益越多",
	"销毁我的团队.质押NFT": "質押NFT",
	"销毁我的团队.质押NFT后将解锁团队极差奖励功能，享受1%-5%的团队收益分成": "質押NFT後將解鎖團隊極差獎勵功能，享受1%-5%的團隊收益分成",
	"销毁我的团队.NFT数量": "NFT數量",
	"销毁我的团队.个": "個",
	"销毁我的团队.质押周期": "質押週期",
	"销毁我的团队.永久": "永久",
	"销毁我的团队.团队极差": "團隊極差",
	"销毁我的团队.确认质押": "確認質押",


	"NUT.菜单.首页": "首頁",
	"NUT.菜单.奖励": "獎勵",
	"NUT.菜单.介绍": "介紹",
	"NUT.菜单.奖励池": "獎勵池",

	"NUT.首页.活跃": "活躍",
	"NUT.首页.下一代DeFi生态代币": "下一代DeFi生態代幣",
	"NUT.首页.燃烧池": "燃燒池",
	"NUT.首页.稳定池": "穩定池",
	"NUT.首页.托底池": "托底池",
	"NUT.首页.LP奖励": "LP獎勵",
	"NUT.首页.参与质押": "參與質押",
	"NUT.首页.参与激励": "參與激勵",
	"NUT.首页.我的参与统计": "我的參與統計",
	"NUT.首页.总参与": "總參與",
	"NUT.首页.份数": "份數",
	"NUT.首页.预计收益": "預計收益",
	"NUT.首页.参与数量": "参与数量",
	"NUT.首页.余额": "餘額",
	"NUT.首页.最大": "最大",
	"NUT.首页.份": "份",
	"NUT.首页.参与规则说明": "參與規則說明",
	"NUT.首页.1,000 ROON =1份，可多次参与": "1,000 ROON =1份，可多次參與",
	"NUT.首页.35%全网分红ROON": "35%全網分紅ROON",
	"NUT.首页.65%自动组LP锁定999年": "65%自動組LP鎖定999年",
	"NUT.首页.全链上执行，透明可查": "全鏈上執行，透明可查",
	"NUT.首页.收益分配": "收益分配",
	"NUT.首页.全网分红": "全網分紅",
	"NUT.首页.组LP锁定": "組LP鎖定",
	"NUT.首页.65 ROON中:32.5买入NUT + 32.5 ROON组LP": "65 ROON中:32.5買入NUT + 32.5 ROON組LP",
	"NUT.首页.最少": "最少",

	"NUT.奖励.我的奖励总览": "我的獎勵總覽",
	"NUT.奖励.可领取奖励": "可領取獎勵",
	"NUT.奖励.已领取总额": "已領取總額",
	"NUT.奖励.税收分红": "稅收分紅",
	"NUT.奖励.持币分红": "持幣分紅",
	"NUT.奖励.LP奖励": "LP獎勵",
	"NUT.奖励.NFT分红": "NFT分紅",
	"NUT.奖励.税收分红领取": "稅收分紅領取",
	"NUT.奖励.盈利税+砸盘税": "盈利稅+砸盤稅",
	"NUT.奖励.盈利税分红": "盈利稅分紅",
	"NUT.奖励.回购": "回購",
	"NUT.奖励.砸盘税分红": "砸盤稅分紅",
	"NUT.奖励.总可领取": "總可領取",
	"NUT.奖励.领取时50%销毁，50%到账": "領取時50%銷毀，50%到賬",
	"NUT.奖励.税收机制说明": "稅收機制說明",
	"NUT.奖励.盈利税20%:回购ROON分红给参与者": "盈利稅20%:回購ROON分紅給參與者",
	"NUT.奖励.盘税25%:每日8点AVE价格为准，跌1%扣2%": "盤稅25%:每日8點AVE價格為準，跌1%扣2%",
	"NUT.奖励.最高下跌12.5%时税率达25%": "最高下跌12.5%時稅率達25%",
	"NUT.奖励.领取税收分红": "領取稅收分紅",

	"NUT.奖励.持币分红": "持幣分紅",
	"NUT.奖励.手续费": "手續費",
	"NUT.奖励.可领取": "可領取",
	"NUT.奖励.下次分红": "下次分紅",
	"NUT.奖励.已领取": "已領取",
	"NUT.奖励.参与条件": "參與條件",
	"NUT.奖励.持有": "持有",
	"NUT.奖励.领取费用": "領取費用",
	"NUT.奖励.价值": "價值",
	"NUT.奖励.领取时50%销毁，50%到账": "領取時50%銷毀，50%到賬",
	"NUT.奖励.领取奖励": "領取獎勵",

	"NUT.奖励.LP贡献奖励": "LP貢獻獎勵",
	"NUT.奖励.我的流动性": "我的流動性",
	"NUT.奖励.池份额": "池份額",
	"NUT.奖励.LP每小时自动撤出0.25%，0.125%燃烧，0.125%分红": "LP每小時自動撤出0.25%，0.125%燃燒，0.125%分紅",
	"NUT.奖励.添加流动性": "添加流動性",
	"NUT.奖励.流动性池": "流動性池",
	"NUT.奖励.当前池子比例": "當前池子比例",
	"NUT.奖励.数量": "數量",
	"NUT.奖励.余额": "餘額",
	"NUT.奖励.请输入NUT数量": "請輸入NUT數量",
	"NUT.奖励.请输入ROON数量": "請輸入ROON數量",
	"NUT.奖励.最大": "最大",
	"NUT.奖励.花店容差": "花店容差",
	"NUT.奖励.自定义": "自定義",
	"NUT.奖励.取消": "取消",
	"NUT.奖励.确认添加": "確認添加",

	"NUT.奖励.NFT资产分红": "NFT資產分紅",
	"NUT.奖励.盈利税": "盈利稅",
	"NUT.奖励.节点NFT": "節點NFT",
	"NUT.奖励.白名单NFT": "白名單NFT",
	"NUT.奖励.持有": "持有",
	"NUT.奖励.个": "個",
	"NUT.奖励.NFT分红规则": "NFT分紅規則",
	"NUT.奖励.节点NFT:50%分红(权重值分配)": "節點NFT:50%分紅(權重值分配)",
	"NUT.奖励.白名单NFT:50%分红(加权平均)": "白名單NFT:50%分紅(加權平均)",
	"NUT.奖励.激活条件: 持币≥100.000 NUT": "激活條件: 持幣≥100.000 NUT",
	"NUT.奖励.领取时50%销毁，50%到账": "領取時50%銷毀，50%到賬",
	"NUT.奖励.领取全部NFT奖励": "領取全部NFT獎勵",

	"NUT.介绍.NUT 代币": "NUT 代幣",
	"NUT.介绍.创新的Defi生态系统，多重分红机制": "創新的Defi生態系統，多重分紅機制",
	"NUT.介绍.代币信息": "代幣信息",
	"NUT.介绍.代币名称": "代幣名稱",
	"NUT.介绍.NUT 代币": "NUT 代幣",
	"NUT.介绍.代币符号": "代幣符號",
	"NUT.介绍.总供应量": "總供應量",
	"NUT.介绍.一千万亿": "一千萬億",
	"NUT.介绍.稳定比": "穩定比",
	"NUT.介绍.美元兑日元": "美元兌日元",
	"NUT.介绍.奖励代币": "獎勵代幣",
	"NUT.介绍.三大资金池": "三大資金池",
	"NUT.介绍.燃烧池": "燃燒池",
	"NUT.介绍.NUT/ROON 交易对，持续燃烧通缩": "NUT/ROON 交易對，持續燃燒通縮",
	"NUT.介绍.稳定池": "穩定池",
	"NUT.介绍.NUT/USDR 交易对，价格稳定支": "NUT/USDR 交易對，價格穩定支",
	"NUT.介绍.拖底池": "拖底池",
	"NUT.介绍.ROON 转账即交易，X314协议，隐藏性拖底": "ROON 轉賬即交易，X314協議，隱藏性拖底",
	"NUT.介绍.交易手续费分配": "交易手續費分配",
	"NUT.介绍.回流底池燃烧": "回流底池燃燒",
	"NUT.介绍.回流ROON LP池": "回流ROON LP池",
	"NUT.介绍.价格拖底": "價格拖底",
	"NUT.介绍.生态建设": "生態建設",
	"NUT.介绍.持币分红": "持幣分紅",
	"NUT.介绍.回购销毁": "回購銷毀",
	"NUT.介绍.LP池机制": "LP池機制",
	"NUT.介绍.LP每小时自动撤出0.25%": "LP每小時自動撤出0.25%",
	"NUT.介绍.其中0.125%自动燃烧销毁": "其中0.125%自動燃燒銷毀",
	"NUT.介绍.另外0.125%分红给LP提供者": "另外0.125%分紅給LP提供者",
	"NUT.介绍.1%手续费实时分红给LP用户": "1%手續費實時分紅給LP用戶",
	"NUT.介绍.参与质押机制": "參與質押機制",
	"NUT.介绍.向合约地址打入ROON代币100": "向合約地址打入ROON代幣100",
	"NUT.介绍.ROON=1份，可多次参与": "ROON=1份，可多次參與",
	"NUT.介绍.全链上执行，透明可查": "全鏈上執行，透明可查",
	"NUT.介绍.收益分配": "收益分配",
	"NUT.介绍.35%全网分红ROON": "35%全網分紅ROON",
	"NUT.介绍.65%自动组LP锁定999年": "65%自動組LP鎖定999年",
	"NUT.介绍.65 ROON中:32.5买入NUT + 32.5 ROON组LP": "65 ROON中:32.5買入NUT + 32.5 ROON組LP",
	"NUT.介绍.税收机制": "稅收機制",
	"NUT.介绍.盈利税（20%）": "盈利稅（20%）",
	"NUT.介绍.20%回购ROON分给参与者": "20%回購ROON分給參與者",
	"NUT.介绍.其中10%分红给LP用户": "其中10%分紅給LP用戶",
	"NUT.介绍.5%的利润将分给NFT资产持有者": "5%的利潤將分給NFT資產持有者",
	"NUT.介绍.5%用于市值管理": "5%用於市值管理",
	"NUT.介绍.砸盘税 (最高25%)": "砸盤稅 (最高25%)",
	"NUT.介绍.每天早上8点AVE价格为准": "每天早上8點AVE價格為準",
	"NUT.介绍.跌1%扣2%手续费": "跌1%扣2%手續費",
	"NUT.介绍.最高下跌12.5%时税率达25%": "最高下跌12.5%時稅率達25%",
	"NUT.介绍.25% 回购ROON分给参与者": "25% 回購ROON分給參與者",
	"NUT.介绍.持币分红": "持幣分紅",
	"NUT.介绍.0.5%手续费用于持币分红ROON": "0.5%手續費用於持幣分紅ROON",
	"NUT.介绍.单地址持币>100,000 NUT可参与": "單地址持幣>100,000 NUT可參與",
	"NUT.介绍.前台手动领取，支付50% NUT价值": "前台手動領取，支付50% NUT價值",
	"NUT.介绍.领取时50%销毁，50%到账": "領取時50%銷毀，50%到賬",
	"NUT.介绍.NFT分红机制": "NFT分紅機制",
	"NUT.介绍.节点NFT(50%)": "節點NFT(50%)",
	"NUT.介绍.权重值分配分红": "權重值分配分紅",
	"NUT.介绍.持币≥100.000 NUT激活": "持幣≥100.000 NUT激活",
	"NUT.介绍.白名单NFT(50%)": "白名單NFT(50%)",
	"NUT.介绍.加权平均分配分红": "加權平均分配分紅",
	"NUT.介绍.持币≥100.000 NUT激活": "持幣≥100.000 NUT激活",
	"NUT.介绍.重要提示": "重要提示",
	"NUT.介绍.所有盈利税和砸盘税分红ROON": "所有盈利稅和砸盤稅分紅ROON",
	"NUT.介绍.领取时50%打入黑洞销毁，50%到用户钱包": "領取時50%打入黑洞銷毀，50%到用戶錢包",
	"NUT.介绍.全链上执行，透明可查": "全鏈上執行，透明可查",
	"NUT.介绍.智能合约自动执行，无需人工干预": "智能合約自動執行，無需人工干預",

	"NUT.奖励池.资金池总览": "資金池總覽",
	"NUT.奖励池.实时监控三大资金池运作状态": "實時監控三大資金池運作狀態",
	"NUT.奖励池.资金池总价值": "資金池總價值",
	"NUT.奖励池.24小时注入": "24小時注入",
	"NUT.奖励池.24小时分配": "24小時分配",
	"NUT.奖励池.24小时销毁": "24小時銷毀",
	"NUT.奖励池.LP池": "LP池",
	"NUT.奖励池.质押池": "質押池",
	"NUT.奖励池.税收池": "稅收池",
	"NUT.奖励池.LP池流动性池": "LP池流動性池",
	"NUT.奖励池.运行中": "運行中",
	"NUT.奖励池.交易手续费的35%注入LP池，增强流动性": "交易手續費的35%注入LP池，增強流動性",
	"NUT.奖励池.池子总价值": "池子總價值",
	"NUT.奖励池.今日注入": "今日注入",
	"NUT.奖励池.累计分配": "累計分配",
	"NUT.奖励池.累计注入": "累計注入",
	"NUT.奖励池.查看详细数据": "查看詳細數據",
	"NUT.奖励池.操作记录": "操作記錄",
	"NUT.奖励池.查看全部": "查看全部",
	"NUT.奖励池.注入": "注入",
	"NUT.奖励池.加载更多": "加載更多",

	"NUT.奖励池.LP流动性池": "LP流動性池",
	"NUT.奖励池.详细数据分析": "詳細數據分析",
	"NUT.奖励池.概览": "概覽",
	"NUT.奖励池.图表": "圖表",
	"NUT.奖励池.记录": "記錄",
	"NUT.奖励池.占比": "佔比",
	"NUT.奖励池.数量": "數量",
	"NUT.奖励池.LP代币": "LP代幣",
	"NUT.奖励池.持有人数": "持有人數",
	"NUT.奖励池.年华收益": "年華收益",
	"NUT.奖励池.日奖励": "日獎勵",
	"NUT.奖励池.7日资金流动趋势": "7日資金流動趨勢",
	"NUT.奖励池.资金分配占比": "資金分配佔比",
	"NUT.奖励池.回购": "回購",
	"NUT.奖励池.销毁": "銷毀",
	"NUT.奖励池.分配": "分配",

	"NUT.奖励池.质押奖励池": "質押獎勵池",
	"NUT.奖励池.交易手续费的25%用于质押奖励分配": "交易手續費的25%用於質押獎勵分配",
	"NUT.奖励池.总质押量": "總質押量",
	"NUT.奖励池.质押人数": "質押人數",
	"NUT.奖励池.平均质押": "平均質押",
	"NUT.奖励池.待领奖励": "待領獎勵",
	"NUT.奖励池.待领奖励": "待領獎勵",

	"NUT.奖励池.税收回购池": "稅收回購池",
	"NUT.奖励池.交易手续费的40%用于税收回购和销毁": "交易手續費的40%用於稅收回購和銷毀",
	"NUT.奖励池.今日回购": "今日回購",
	"NUT.奖励池.累计销毁": "累計銷毀",
	"NUT.奖励池.盈利税": "盈利稅",
	"NUT.奖励池.砸盘税": "砸盤稅",
	"NUT.奖励池.回购总额": "回購總額",
	"NUT.奖励池.销毁总额": "銷毀總額",
	"NUT.奖励池.分配总额": "分配總額",
	"NUT.奖励池.日回购": "日回購",

	"弹窗.复制成功": "複製成功",
	"弹窗.复制失败": "複製失敗",
	"弹窗.確認": "確認",
	"弹窗.取消": "取消",
	"弹窗.上级邀请码": "上級邀請碼",
	"弹窗.知道了": "知道了",
	"弹窗.请输入邀请码": "請輸入邀請碼",

	"吐司.敬请期待": "敬請期待",
	"吐司.操作成功": "操作成功",
	"吐司.操作失败": "操作失敗",
	"吐司.请在钱包中打包": "請在錢包中打包",
	"吐司.暂未开放": "暫未開放",
	"吐司.用户拒绝提供程序访问": "用戶拒絕提供程序訪問",
	"吐司.请刷新重试": "請刷新重試",
	"吐司.请输入邀请码": "請輸入邀請碼",
	"吐司.操作成功请稍后刷新查看": "操作成功，請稍後刷新查看",
	"吐司.添加流动性成功": "添加流動性成功",
	"吐司.购买成功": "購買成功",

	"解押NFT":"解押NFT",
	"质押NFT":"質押NFT",
	"选择NFT解押":"選擇NFT解押",
	"选择NFT质押":"選擇NFT質押",
	"当前节点等级:黄金":"當前節點等級:",
	"jiemiao":"只能解押 Level3 的NFT",
	"zhimiao":"只能質押 Level3 的NFT",
	"已选择":"已選擇",
	'黄金':'黃金',
	'解押':'解押',
	'质押':'質押',
	'个':'個',

    "吐司.余额不足": "餘額不足",
    "吐司.收款地址无效": "收款地址無效",

	"添加流动性": "添加流動性",

	"交换代币": "交換代幣",
	"从": "從",
	"余额": "餘額",
	"请输入": "請輸入",
	"至": "至",
	"池股份": "池股份",
	"当前年利率": "當前年利率",
	"代币": "代幣",
	"热门池": "熱門池",
	"兑换美元稳定币兑换": "兌換美元穩定幣兌換",
	"以太坊": "以太坊",
	"亿美元": "億美元",
	"四月": "四月",
	"我的流动池": "我的流動池",
	"总计": "總計",
	"我的稳定币": "我的穩定幣",
	"小时交易量": "小時交易量",
	"百万": "百萬",
	"移除": "移除",
	"添加更多": "添加更多",
	"总薪酬": "總薪酬",
	"池": "池",
	"交易池": "交易池",
	"领取所有奖励": "領取所有獎勵",
	"移除流动性": "移除流動性",
	"确定要移除": "確定要移除：",
	"我的流动性": "我的流動性",
	"预计收益": "預計收益",
	"取消": "取消",
	"确认移除": "確認移除",
	"跨链桥": "跨鏈橋",
	"预计到账时间": "預計到賬時間",
	"分钟到账": "分鐘到賬",
	"安全级别": "安全級別",
	"高": "高",
	"手续费": "手續費",
	"美元": "美元",
	"多边形": "多邊形",
	"代币数量": "代幣數量",
	"美元稳定币": "美元穩定幣",
	"接收地址": "接收地址",
	"分钟": "分鐘",
	"桥接手续费": "橋接手續費",
	"目标链手续费": "目標鏈手續費",
	"总手续费": "總手續費",
	"开始跨链": "開始跨鏈",
	"最近跨链记录": "最近跨鏈記錄",
	"分钟前": "分鐘前",
	"待处理": "待處理",
	"完成": "完成",
	"支持的网络": "支持的網絡",
	"企业绩效管理": "企業績效管理",
	"选择币种": "選擇幣種",
	"滑点容差": "滑點容差",
	"费率": "費率",
	"滑动": "滑動",
	"百分比": "百分比",
	"网络费用": "網絡費用",
	"最近的交换": "最近的交換",

	"我的池": "我的流動性池",
	'使用我的地址':'使用我的地址',
	    "我的LP.暂无数据": "暂无数据",
	    "我的LP.复投": "複投",
	}


